import { WSService } from "../../utils/WSService";

export const serviceNotifications = new WSService("/notifications");
